import { getDataChannel } from "@/stores/modules/machineLog/machineLogHelper";
import { machineMessageStoreApi } from "@/api/machineMessageStoreApi";
import Vue from "vue";

export default {
  state: {
    alarms: {},
    productions: {},
    events: {}
  },
  getters: {
    getAlarmsByMachineId: state => id => {
      const elements = state.alarms[id];
      const items = (elements && elements.items) || [];
      return items;
    },
    getProdsByMachineId: state => id => {
      const elements = state.productions[id];
      const items = (elements && elements.items) || [];
      return items;
    },
    getEventsByMachineId: state => id => {
      const elements = state.events[id];
      const items = (elements && elements.items) || [];
      return items;
    }
  },
  actions: {
    async fetchAllLogs({ commit }, { machineId, from, to, type }) {
      if (machineId) {
        const data = await machineMessageStoreApi.getAllItems(machineId, getDataChannel(type), {
          after: from,
          before: to,
          type
        });

        commit("SET_ITEMS", {
          type,
          data,
          machineId,
          from,
          to
        });
      }
    },
    clearItems: ({ commit }) => {
      commit("RESET");
    }
  },
  mutations: {
    SET_ITEMS: (state, payload) => {
      if (payload) {
        const { data, machineId, from, to, type } = payload;
        const items = (data || []).map(el => {
          return el.value;
        });

        Vue.set(state[type], machineId, {
          items,
          from,
          to
        });
      }
    },
    RESET: state => {
      state.alarms = {};
      state.productions = {};
      state.events = {};
    }
  },
  namespaced: true
};
